<template>
    <div class="guide-paginate" v-if="guide.pageCount" v-html="paginater"></div>
</template>

<script src="./guide-paginate.js"></script>

<style lang="scss">
@use './guide-paginate.scss' as *;
</style>